import { COLLAGE_LAYOUTS_OPTIONS } from '../../constants/proGalleryConstants';
import { LAYOUTS } from '../../constants/settingsConstants';
import { getCurrentSettings } from './gallerySettings';
import { getGalleryInfo } from './galleryHeight';
import { loadMoreCollageUpdateHeight1 } from './collageHeight';

/**
 * Grid - Update proGallery height when load more medias
 */
const loadMoreGridUpdateHeight = (type) => (dispatch) => {
  const { numberOfImagesPerRow, numRows } = getCurrentSettings(type);
  let {
    height,
    items,
    typeActionMoreData,
    countRowDisplay,
    isDispalyShowMoreBtn,
    sectionHeight,
    rowHeight,
  } = getGalleryInfo(type);

  let countRowNeedToDisplay =
    countRowDisplay === 0 ? numRows * 2 : countRowDisplay + numRows;
  isDispalyShowMoreBtn =
    isDispalyShowMoreBtn &&
    countRowNeedToDisplay * numberOfImagesPerRow < items.length;
  let countRowNeedToAddNow = countRowNeedToDisplay;

  if (!isDispalyShowMoreBtn) {
    // Check if we fill all rows and if not fix count row to display
    countRowNeedToAddNow =
      Math.ceil(items.length / numberOfImagesPerRow) - countRowDisplay;
    sectionHeight = rowHeight * countRowNeedToAddNow;
    countRowNeedToDisplay = countRowDisplay + countRowNeedToAddNow;
  }

  height += sectionHeight;
  window.Wix.setHeight(window.innerHeight + sectionHeight);

  dispatch({
    type: typeActionMoreData,
    payload: {
      countRowDisplay: countRowNeedToDisplay,
      isDispalyShowMoreBtn,
      height,
      isLoadedMore: true,
    },
  });
};

/**
 * Update proGallery height when load more medias
 */
export const loadMoreUpdateHeight = (type) => (dispatch) => {
  const { galleryLayout } = getGalleryInfo(type);

  switch (galleryLayout) {
    case LAYOUTS.GRID:
      dispatch(loadMoreGridUpdateHeight(type));
      break;
    case LAYOUTS.COLLAGE:
      dispatch(loadMoreCollageUpdateHeight1(type));
      break;
    case LAYOUTS.SLIDER:
      // In slider Layout the height no change.
      break;
    default:
      break;
  }
};
